import { render } from "./SignupPage.vue?vue&type=template&id=7336ebf8"
import script from "./SignupPage.vue?vue&type=script&lang=js"
export * from "./SignupPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__